import { ExperimentComponent } from './pages/experiment/experiment.component';
import { HomeComponent } from './pages/home/home.component';
import { Routes } from '@angular/router';
import { authGuard } from './auth/auth.guard';
import { CallbackComponent } from './pages/callback/callback.component';
import { UploadDataComponent } from './pages/upload-data/upload-data.component';

export const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'callback', component: CallbackComponent },
  {
    path: 'experiment/:participantIdentifier/:trialSequenceNumber',
    component: ExperimentComponent,
  },
  { path: 'home', component: HomeComponent },
  {
    path: 'upload_data/:participantIdentifier',
    component: UploadDataComponent,
    canActivate: [authGuard],
  },
];
